export const messages = {
  lessThanHundred: "Must be less than 100",
  numbersOnly: "Numbers only",
  noNegativeNumbers: "Must be positive",
};
